module.exports = __webpack_public_path__ + "img/Sass_icon.ffb9976a.png";